/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import DetailsButton from '../../../components/Button/DetailsButton';
// import TitleInfo from '../../../components/Text/TitleInfo';

const PackageList = () => {
    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('package-management'));
    const navigate = useNavigate();

    console.log('Package Result =', result);

    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const columns = [
        {
            name: 'Name',
            wrap: true,
            center: 'true',
            selector: (row) => row?.name,
        },
        {
            name: 'Image',
            width: '100px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.image}`}
                    alt='Package'
                />
            ),
        },
        {
            name: 'Price',
            wrap: true,
            center: 'true',
            width: '100px',
            cell: (row) =>
                <div>{row.price} TK </div>,
        },
        {
            name: 'Discount',
            wrap: true,
            center: 'true',
            width: '100px',
            cell: (row) => <div>{row.package_discount} % </div>,
        },
        //! Error
        //! First create facility module then load data from facitly table.
        // {
        //     name: 'Facilities',
        //     wrap: true,
        //     center: 'true',
        //     cell: (row) => (
        //         <div>
        //             {row.facility?.map((item) => (
        //                 <ul key={item.id}>
        //                     <li> {item?.name} </li>
        //                 </ul>
        //             ))}
        //         </div>
        //     ),
        // },

        // {
        //     name: 'Features',
        //     wrap: true,
        //     center: 'true',
        //     cell: (row) => (
        //         <div>
        //             {row.package_features?.map((item) => (
        //                 <ul key={item.id}>
        //                     <li> {item?.name} </li>
        //                 </ul>
        //             ))}
        //         </div>
        //     ),
        // },

        {
            name: 'Duration',
            // wrap: true,
            // center: 'true',
            selector: (row) => row?.duration,
        },
        {
            name: 'Month',
            // wrap: true,
            center: 'true',
            width: '200px',
            // selector: (row) => row?.package_months,
            cell: (row) => (
                <div>
                    {row.package_months?.map((item) => (
                        <ul key={item?.id}>
                            <li> {item?.month?.name} </li>
                        </ul>
                    ))}
                </div>
            ),
        },
        {
            name: 'Travel Category',
            // wrap: true,
            // center: 'true',
            width: "200px",
            selector: (row) => row?.travelCategory?.name,
        },
        {
            name: 'Tour Types ID',
            // wrap: true,
            // center: 'true',
            width: "200px",
            selector: (row) => row?.tourType?.name,
        },
        {
            name: 'Destination',
            center: 'true',
            width: "200px",
            selector: (row) => row?.destination?.country_name,
        },
        {
            name: 'Min Age',
            wrap: true,
            center: 'true',
            selector: (row) => row?.min_age,
        },
        {
            name: 'Description',
            wrap: true,
            center: 'true',
            width: "200px",
            selector: (row) => < div dangerouslySetInnerHTML={{ __html: row?.description }} />,
        },
        // {
        //     name: 'Facility',
        //     wrap: true,
        //     center: 'true',
        //     selector: (row) => row?.facility,
        // },
        // {
        //     name: 'Facilities',
        //     wrap: true,
        //     center: 'true',
        //     selector: (row) => row?.description,
        //     // cell: (row) => (
        //     //     <div>
        //     //         {row.facility?.map((item) => (
        //     //             <ul key={item.id}>
        //     //                 <li> {item?.value} </li>
        //     //             </ul>
        //     //         ))}
        //     //     </div>
        //     // ),
        // },
        {
            name: 'Highlights Description',
            wrap: true,
            center: 'true',
            width: "200px",
            selector: (row) => row?.highlights_description,
        },
        {
            name: 'Points',
            wrap: true,
            center: 'true',
            width: "200px",
            cell: (row) => (
                <div>
                    {row.points?.map((item) => (
                        <ul key={item.id}>
                            <li> {item?.value} </li>
                        </ul>
                    ))}
                </div>
            ),
        },
        // {
        //     name: 'Points',
        //     wrap: true,
        //     center: 'true',
        //     cell: (row) => {
        //         let bulletPoints = [];
        //         try {
        //             const parsedData = JSON.parse(row?.highlights_bulletpoints); if (Array.isArray(parsedData)) { bulletPoints = parsedData.filter((item) => item?.value != null); }
        //         } catch (error) {
        //             console.error('Failed to parse JSON or filter data:', error);
        //         }
        //         return (
        //             <div>
        //                 <ul className='list-none p-0 flex items-center space-x-2 my-4'>
        //                     {
        //                         bulletPoints.length > 0 ? (bulletPoints.map((item, index) => (<li key={index}>
        //                             <span>{item.value}</span>
        //                         </li>))) : (<li>No points available</li>)} </ul>
        //             </div>);
        //     },
        // },
        {
            name: 'Includes',
            wrap: true,
            center: 'true',
            width: "200px",
            cell: (row) => (
                <div>
                    {row.includes?.map((item) => (
                        <ul key={item.id}>
                            <li> {item?.value} </li>
                        </ul>
                    ))}

                </div>
            ),
        },
        {
            name: 'Excluded',
            wrap: true,
            center: 'true',
            width: "200px",
            cell: (row) => (
                <div>
                    {row.excludes?.map((item) => (
                        <ul key={item.id}>
                            <li> {item?.value} </li>
                        </ul>
                    ))}
                </div>
            ),
        },
        {
            name: 'Itinerary ',
            wrap: true,
            center: 'true',
            width: "200px",
            cell: (row) => (
                <div>
                    {row.itineraries?.map((item) => (
                        <ul key={item.id}>
                            <li> {item?.value} </li>
                        </ul>
                    ))}

                </div>
            ),
            // selector: (row) => row?.itinerary,
            // cell: (row) => (
            //     <div>
            //         {row.itinerary?.map((item) => (
            //             <ul key={item.id}>
            //                 <li> {item?.itinerary} </li>
            //             </ul>
            //         ))}
            //     </div>
            // ),
        },
        {
            name: 'Location',
            center: 'true',
            selector: (row) => row?.destination?.country_name,
        },
        {
            name: 'Featured',
            center: 'true',
            selector: (row) => (row?.featured === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Popular',
            center: 'true',
            selector: (row) => (row?.popular === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Action',
            center: 'true',
            cell: (row) => (
                <div>
                    {/* <DetailsButton
                        onClick={() => {
                            setModalOpen('details');
                            setSelectedItem(row);
                        }}
                    /> */}
                    <EditButton
                        onClick={() => navigate(`/dashboard/website/packages/edit/${row?.id}`)}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // delete function

    const abotUsDeleteHandler = () =>
        request.delete('package-management', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Package List'
            buttonTitle='Add New Package'
            addButtonHandler={() => navigate('/dashboard/website/packages/add')}
        >
            <ReactDataTable columns={columns} data={result} pending={isLoading} />

            {/* delete about us */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={abotUsDeleteHandler}
                />
            )}
        </CardLayout>
    );
};

export default PackageList;
